import { render, staticRenderFns } from "./AbnormalSendOrder.vue?vue&type=template&id=51c2c620&scoped=true&"
import script from "./AbnormalSendOrder.vue?vue&type=script&lang=js&"
export * from "./AbnormalSendOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2c620",
  null
  
)

component.options.__file = "AbnormalSendOrder.vue"
export default component.exports